import React from 'react'
import Navbar from '../Home/Navber.jsx'
import HeroSection from './HeroSection.jsx'
import ServicesGrid from './Services.jsx'
import Footer from '../Home/Footer.jsx'

function ServicesMain() {
  return (
    <div>
      <Navbar/> 
      <HeroSection/> 
      <ServicesGrid/>
      <Footer/>
    </div>
  )
}

export default ServicesMain